import { EmpresaDto } from "../Entidade/Empresa/Empresa.Dto";
import { MinhaContaDto } from "../MinhaConta/MinhaConta.Dto";

export const STORAGE_CADASTRO_INICIAL_EMPRESA = "cadastro_inicial_empresa";
export const STORAGE_CADASTRO_INICIAL_USUARIO = "cadastro_inicial_usuario";
export const STORAGE_CADASTRO_INICIAL_EMPRESA_SALVA =
  "cadastro_inicial_empresa_salva";

export function getCadastroInicialLocal<T>(key: string): T | null {
  const stored = sessionStorage.getItem(key);
  return stored ? (JSON.parse(stored) as T) : null;
}

export function setCadastroInicialLocal<T>(key: string, data: T | null) {
  if (data === null) {
    sessionStorage.removeItem(key);
  } else {
    sessionStorage.setItem(key, JSON.stringify(data));
  }
}

export function limparCadastroInicialLocal() {
  sessionStorage.removeItem(STORAGE_CADASTRO_INICIAL_EMPRESA);
  sessionStorage.removeItem(STORAGE_CADASTRO_INICIAL_USUARIO);
  sessionStorage.removeItem(STORAGE_CADASTRO_INICIAL_EMPRESA_SALVA);
}

export const STORAGE_COMPLETAR_CADASTRO_USUARIO = "completar_cadastro_usuario";

export function isPendenteCadastroUsuario(userId?: number | string): boolean {
  const value = localStorage.getItem(STORAGE_COMPLETAR_CADASTRO_USUARIO);
  if (!value) return false;
  if (value === "true") return true;
  if (userId !== undefined && value === String(userId)) return true;
  return false;
}

export function setPendenteCadastroUsuario(userId?: number | string) {
  localStorage.setItem(
    STORAGE_COMPLETAR_CADASTRO_USUARIO,
    userId ? String(userId) : "true"
  );
}

export function limparPendenteCadastroUsuario() {
  localStorage.removeItem(STORAGE_COMPLETAR_CADASTRO_USUARIO);
}

